import React from 'react';
import { useTranslation } from 'react-i18next';

export default function AppInput({
  type = "text",
  id,
  value,
  onChange,
  required = false,
  disabled = false,
  placeholder,
  className = "",
  label,
  labelKey,
  options = [],
  variant = "default"
}) {
  const { t } = useTranslation();

  const displayLabel = labelKey ? t(labelKey) : label;
  const inputClass = variant === "language-select" 
    ? `language-select ${className}`.trim() 
    : className;

  const renderInput = () => {
    const baseProps = {
      id,
      value,
      onChange,
      disabled,
      className: inputClass
    };

    if (type === "select") {
      return (
        <select {...baseProps}>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.labelKey ? t(option.labelKey) : option.label}
            </option>
          ))}
        </select>
      );
    }

    return (
      <input
        {...baseProps}
        type={type}
        required={required}
        placeholder={placeholder}
      />
    );
  };

  // Form input with label
  if (displayLabel) {
    return (
      <div className="form-group">
        <label htmlFor={id}>{displayLabel}</label>
        {renderInput()}
      </div>
    );
  }

  // Standalone input (like language selector)
  const containerClass = variant === "language-select" ? "language-switcher" : "";
  
  return (
    <div className={containerClass}>
      {renderInput()}
    </div>
  );
} 